import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'gn',
    fullName: 'Guarani',
    nativeName: 'Guarani',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid rehegua",
    landing_title: "Oúma hína peteĩ mbaʼe hechapyrãva",
    landing_subtitle: "ArgVoid ha’e peteĩ estudio app ha juego desarrollo rehegua. ¡Epyta, pya'e oúta mba'e pyahu!",
    select_language: "Eiporavo Ñe’ẽ",
    search_placeholder: "Ojeporeka ñe'ẽnguéra...",
    terms_title: "Términos de Servicio rehegua",
    policy_title: "Polítika Privasida rehegua",
    cookies_title: "Política de Cookie rehegua",
    terms_content: `
        <strong>1. Ñe’ẽme’ẽ jeguerohory</strong><br>
        Ojeike rupi ArgVoid-pe, ojeacepta ko’ã Condiciones de Servicio. Noñemoĩriramo peteĩ ñe’ẽme ko’ã ñe’ẽme’ẽ, ndojeporúiva’erã pe servicio.<br><br>

        <strong>2. Plataforma Jeporu</strong><br>
        ArgVoid ha umi aplicación oñeme'ẽ "oĩháicha" marandu ha creativo-rã. Pe servicio ojepuruva’erã léipe g̃uarãnte.<br><br>

        <strong>3. Conducta Prohibida</strong><br> rehegua
        Ojeproivi estrictamente ojeaprovecha umi vulnerabilidad sitio rehegua, spam térã oñeha’ãvo ojeike noñeautorisáiva infraestructura-pe.<br><br>

        <strong>4. Ñe’ẽñemi rehegua</strong><br>
        Pe plataforma ha servicio ikatu oñemoambue oimeha ára oñemombe’u’ỹre. Noñeme'êi garantía oñe'êva tiempo de funcionamiento térã disponibilidad servicio rehe.
    `,
    policy_content: `
        <strong>1. Marandu Ñembyaty</strong><br>
        Ko plataforma noikotevẽi puruhára jekuaauka térã cuenta apo ko’áĝaite. Ndaipóri marandu ojekuaaukáva (ha’eháicha téra térã dirección de correo electrónico) oñembyatýva activamente umi visitante-gui.<br><br>

        <strong>2. Jeporu Datos</strong><br> rehegua
        Ikatu oñembyaty análisis básico, anónimo oñentende hag̃ua tráfico sitio rehegua ha oñemyatyrõ hag̃ua umi aplicación. Ko dato ndojejoajúi peteĩteĩva puruhára identidad rehe.<br><br>

        <strong>3. Mbohapyha Ñemboguatarã</strong><br>
        Umi mbohapýha tapicha ikatu ojeporu umi servicio alojamiento ha análisis-pe g̃uarã. Umi práctica privacidad rehegua ko’ã proveedor respectivo oisãmbyhy umi dato anónimo oñemboguatáva infraestructura-pe.<br><br>

        <strong>4. Datokuéra Ñeñangareko</strong><br>
        Oñemotenonde medida de seguridad razonable oñangareko haguã plataforma rehe. Ha katu, ndaipóri método oñembohasa hag̃ua Internet rupive ndojejokóiva enteramente.<br><br>
    `,
    cookies_content: `
        <strong>1. Mba’épa umi Cookie ha Almacenamiento Local?</strong><br>
        Umi cookie ha kundahára ñeñongatuha tendápe haꞌehína umi vore dato michĩva oñeñongatúva tembipuru’ípe imanduꞌa hag̃ua ñemboheko ñembohekorã rehe opaite jeike rupive.<br><br>

        <strong>2. Jeporurã Rembipota</strong><br>
        Navegador LocalStorage ojepuru mbarete oñeñongatu hag̃ua ñembohekorã ñemboheko, haꞌeháicha:<br>
        - Ñe’ẽ jeporavopyre<br>
        - Pojoapy puruhára ñemohendapyre (techapyrã, ñemohenda térã tema ñemboheko)<br>
        - Cache aplicación sapy’agua<br><br>

        <strong>3. Ndaipóri Seguimiento</strong><br>
        Umi cookie ha almacenamiento local ndojeporúi publicidad térã seguimiento mbohapýha tapicha rehegua. Opaite dato oñeñongatúva haꞌe estrictamente funcionalidad núcleo plataforma-pe g̃uarã.<br><br>

        <strong>4. Control</strong><br> rehegua
        Kundahára marandu ikatu oñembogue oimeha ára kundahára ñemboheko rupive, omoĩjeýtava oimeraẽva ñemboheko tetãmegua.
    `,
    cookie_consent_text: "Roipuru cookies básicos roñangareko hag̃ua ñanduti renda omba’apo porã hag̃ua, taha’e roñongatu ne sesión activa, roñongatu ne ñe’ẽ poravopyre ha ambue configuración personalizada.",
    read_policy: "Emoñe’ẽ Polítika Cookie rehegua",
    support_title: "Eñe’ẽ Soporte ndive",
    support_subject_label: "Ñe'ẽrã",
    support_message_label: "Marandu",
    support_submit_button: "Emondo Marandu",
    support_hint: "Ñe’ẽñemi: Kóva oipe’áta ne purupyrã ñe’ẽmondo rehegua ñepyrũrã omondo hag̃ua marandu.",
    support_success_msg: "Oipe’ávo nde app correo electrónico rehegua...",
    support_error_msg: "Ndoikói omondo haguã marandu. Eñeha’ã jey upe rire.",
    explorer_title: "Explorador rehegua",
    history_title: "Tembiasakue",
    animation_title: "Animación rehegua",
    config_title: "Configuración rehegua",
    tool_mouse: "Eiporavo (Ctrl+M) .",
    tool_brush: "Cepillo (Ctrl+B) rehegua .",
    tool_brush_mode: "Modo de Toggle (Sólido/Hesakãva) .",
    tool_eraser: "Borrador (Ctrl+E) rehegua .",
    tool_brush_size: "Oñemohenda Pincel Tamaño",
    tool_bucket: "Omyenyhẽ (Ctrl+F) .",
    tool_eyedropper: "Tesa ryru",
    tool_grid: "Rejilla (Ctrl + Mayúscula + B) .",
    tool_rotate: "Ojere (Ctrl + Mayúscula + R) .",
    tool_flip_h: "Ojere H (Ctrl + Mayúscula + H) .",
    tool_flip_v: "Ojere V (Ctrl + Mayúscula + V) .",
    tool_transpose: "Transponer (Ctrl + Mayúscula + T) rehegua .",
    label_width: "Ipekue",
    label_height: "Yvatekue",
    label_frames: "Marcokuéra papapy",
    label_animation: "Estilo de Animación rehegua",
    label_background_color: "Fondo Color rehegua",
    label_interval: "Intervalo rehegua",
    tool_anim_config: "Animación rehegua Ñemboheko",
    label_new_width: "Ancho Pyahu",
    label_new_height: "Yvate Pyahu",
    label_apply: "Poru",
    label_colors: "Umi sa’y",
    label_size: "Tuichakue",
    label_tolerance: "Techagi",
    val_horizontal: "Ipekuévo",
    val_vertical: "Ñembo'yakua",
    val_sequence: "Takykuerigua",
    val_bounce: "Opopojevy",
    val_random: "Ijykegua",
    val_solid: "Hatãva",
    val_clear: "Hesakã",
    action_add_sheet: "Hoja Pyahu",
    action_import: "Pytaguañemu",
    action_export: "Rova",
    action_sort_projects: "Mohenda",
    sort_date_old: "Itujavéva Primero",
    sort_date_new: "Ipyahuvéva Primero",
    sort_name_az: "Téra (A-Z) .",
    sort_name_za: "Téra (Z-A) .",
    action_new_sprite: "Sprite pyahu",
    action_new_project: "Proyecto Pyahu",
    modal_save_all_title: "Eñongatu Opaite Ñemoambue",
    modal_save_all_desc: "Eiporavo umi mba’ekuaarã eñongatu hag̃ua:",
    modal_save_selected: "Oñongatu Ojeporavóva",
    action_saved: "Oñongatu",
    modal_create_sprite_title: "Ojapo Sprite Pyahu",
    modal_create_project_title: "Ojapo Proyecto Pyahu",
    modal_add_sheet_title: "Oñemoĩve Hoja Pyahu",
    modal_rename_sheet_title: "Ombohéra jey Hoja",
    modal_rename_sprite_title: "Embohéra jey Sprite",
    modal_delete_sprite_title: "Ombogue Sprite rehegua",
    modal_delete_project_title: "Ombogue Proyecto rehegua",
    modal_delete_sheet_title: "Ombogue Hoja",
    placeholder_sprite_name: "Téra",
    placeholder_project_name: "Téra",
    placeholder_sheet_name: "Téra",
    placeholder_new_name: "Téra Pyahu",
    action_create: "Mboypy",
    action_add: "Moinge",
    action_rename: "Embohéra jey",
    action_duplicate: "Ojejapo jey jey",
    action_delete: "Mboje'oha",
    action_cancel: "Heja",
    confirm_delete_sprite: "¿Eĩpa seguro embogueseha ko sprite?",
    confirm_delete_project: "¿Eĩpa seguro embogueseha ko proyecto? Opaite sprite ojeipe’áta.",
    confirm_delete_sheet: "¿Eĩpa seguro embogueseha ko kuatia?",
    err_select_sprite: "Eiporavo raẽ peteĩ sprite.",
    err_select_project: "Eiporavo raẽ peteĩ tembiapo.",
    err_name_empty: "Téra ndaikatúi oĩ nandi.",
    err_sprite_exists: "Peteĩ sprite upe téra rehegua oĩma.",
    err_project_exists: "Oĩma peteĩ proyecto orekóva upe téra.",
    err_no_content: "Ndaipóri contenido oñeñongatu haguã.",
    err_no_changes: "Ndaipóri ñemoambue oñeñongatu haguã.",
    err_delete_last_sheet: "Ndaikatúi oñembogue pe kuatia paha.",
    err_extract_frames: "Ndaikatúi ojeipe'a mba'eveichagua marco.",
    err_indexeddb: "Ndohupytýi osalva haguã localmente. Ikatu ne kundahára ndoipytyvõi IndexedDB.",
    msg_upload_success: "Ojegueraha porã: {0}",
    msg_upload_failed: "Ojeguerahauka ndoikói: {0}",
    msg_save_success: "Oñongatu osẽ porã.",
    msg_saving: "Oñongatúvo...",
    msg_multi_save_result: "Oñongatu {0} mba’ekuaarã. {1} mba’e’apo’ỹ.",
    menu_title: "Menú rehegua",
    menu_save: "Pysyrõ",
    menu_save_all: "Eñongatu Opavave",
    menu_support: "Eñe’ẽ Soporte ndive",
    label_local_storage: "Almacenamiento Local rehegua",
    label_sign_in: "Eike",
    modal_export_title: "Exportación Sprite rehegua",
    label_filename: "Archivo réra",
    label_format: "Formato rehegua",
    action_export_confirm: "Rova",
};

export default translations;
